(function($){
    $('body').on('click', '.suszka-variations a', function(e){
        e.preventDefault();
        if($(this).hasClass('disabled-variation')){
            $('.suszka-variations .info').remove();
            $(this).closest('.suszka-variations').append('<div class="info">Ten wariant jest niedostępny</div>');
            setTimeout(function(){
                $('.suszka-variations .info').fadeOut(500);
            }, 3500)
            setTimeout(function(){
                $('.suszka-variations .info').remove();
            }, 4001)
        }
        else {
            $('.suszka-variations .info').remove();
            $(this).closest('.jet-woo-product-price').next('.suszka-add-to-cart-button').find('a').attr('href', $(this).attr('href'));
            $(this).closest('.jet-woo-product-price').next('.suszka-add-to-cart-button').find('a').html($(this).attr('data-button-txt'));
            $(this).closest('.jet-woo-product-price').find('.suszka-variations a').removeClass('active');
            $(this).closest('.jet-woo-product-price').find('.price').html($(this).attr('data-price') + ' ' + $(this).attr('data-currency'));
            $(this).closest('.jet-woo-products__item').find('.jet-woo-product-thumbnail').find('a').find('img').attr('src', $(this).attr('data-image'))
            $(this).closest('.jet-woo-products__item').find('.jet-woo-product-thumbnail').find('a').find('img').removeAttr('srcset');
            $(this).addClass('active');
        }
    })
})(jQuery)